import { Controller } from '@hotwired/stimulus';
import NwMap from '../libs/nw_map';

export default class extends Controller {
  static targets = ['image', 'marker', 'input'];

  pickCoordinates(event: MouseEvent) {
    const relativeX = (event.offsetX * 100) / this.imageTarget.width;
    const relativeY = (event.offsetY * 100) / this.imageTarget.height;

    this.setCoordinates(relativeX, relativeY);
  }

  setCoordinates(x: number, y: number) {
    const coordinates = `${x},${y}`;

    if (coordinates.includes('NaN')) {
      this.inputTarget.value = '';
      this.markerTargets[0].setAttribute('style', 'visibility:hidden;');
      this.markerTargets[0].removeAttribute('data-coordinates');
      return;
    }

    this.inputTarget.value = coordinates;
    this.markerTargets[0].setAttribute('data-coordinates', coordinates);

    this.drawMarkers();
  }

  drawMarkers() {
    this.markerTargets.forEach((marker: HTMLElement) => {
      NwMap.drawMarker(this.imageTarget, marker);
    });
  }

  declare imageTarget: HTMLImageElement;

  declare markerTargets: HTMLElement[];

  declare inputTarget: HTMLInputElement;
}
